import FormattedMessage from 'I18n/components/FormattedMessage';
import { TOKEN_INSERT } from 'data-token-picker/constants/PickerModes';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const BrowserTitle = ({
  mode
}) => {
  const titleKey = mode === TOKEN_INSERT ? 'data-token-picker.title.insert' : 'data-token-picker.title.edit';
  return /*#__PURE__*/_jsx(Text, {
    as: "h4",
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey
    })
  });
};
BrowserTitle.displayName = 'BrowserTitle';
export default BrowserTitle;